// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"e10f21f6","957":"fe43f810"}[chunkId] + ".chunk.js";
};